import { DrEntity } from './dr-entity';

export class AuditLog extends DrEntity {
    collectionName: string;
    date: string;
    description: string;
    duration: string;
    eventType: string;
    operationType: string;
    resultCount: number;
    signature: string;
    sriHandle: string;
    swVersion: string;
    user: string;
    workbasketHandle: string;

   constructor(value?: Partial<AuditLog>) {
       super(value);
       if (value) {
           Object.assign(this, value);
       }
   }
}
